import React from 'react';
import { Loader, Notice } from '@origo/origo-ui';
import { ApiError } from '../../api/client';

/** Sentrert loader for panel-innhold som lastes. */
export const PanelLoading: React.FC<{ label?: string }> = ({ label = 'Laster…' }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-03)', padding: 'var(--space-05)' }}>
        <Loader />
        <span style={{ color: 'var(--text-primary-70)', fontSize: 'var(--text-sm)' }}>{label}</span>
    </div>
);

/** Feilmelding som tolker ApiError pent (token/tilkobling/HTTP). */
export const PanelError: React.FC<{ error: unknown; onRetry?: () => void }> = ({ error, onRetry }) => {
    let message = 'Noe gikk galt.';
    let hint: string | null = null;

    if (error instanceof ApiError) {
        message = error.message;
        if (error.status === 401 || error.status === 403) {
            hint = 'API-et avviste tokenet (401/403). Innloggingen kan ha utløpt, eller brukeren din mangler tilgang. Logg ut og inn igjen.';
        } else if (error.status === 0) {
            hint = 'Fikk ikke kontakt med API-et. Kjører forvaltning-api på riktig URL?';
        }
    } else if (error instanceof TypeError) {
        message = 'Fikk ikke kontakt med API-et.';
        hint = 'Sjekk at forvaltning-api kjører (default http://localhost:5022) og at CORS tillater origin.';
    } else if (error instanceof Error) {
        message = error.message;
    }

    return (
        <Notice variant="danger">
            <strong>{message}</strong>
            {hint && <div style={{ marginTop: 'var(--space-01)' }}>{hint}</div>}
            {onRetry && (
                <div style={{ marginTop: 'var(--space-02)' }}>
                    <button
                        type="button"
                        onClick={onRetry}
                        style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', font: 'inherit' }}
                    >
                        Prøv igjen
                    </button>
                </div>
            )}
        </Notice>
    );
};
